import { decryptResponse } from "./encryption";

/**
 * Wrapper for fetch that automatically decrypts encrypted responses
 * @param {string} url - The API endpoint URL
 * @param {object} options - Fetch options (method, headers, body, etc.)
 * @returns {Promise<object>} - Decrypted response data
 */
export const fetchApi = async (url, options = {}) => {
  try {
    const response = await fetch(url, options);

    // Parse JSON response
    const jsonData = await response.json();

    // Decrypt if encrypted (await since decrypt is now async)
    const decryptedData = await decryptResponse(jsonData);

    return decryptedData;
  } catch (error) {
    console.error("API fetch error:", error);
    throw error;
  }
};

/**
 * Helper to make authenticated API calls with automatic decryption
 * @param {string} url - The API endpoint URL
 * @param {string} method - HTTP method (GET, POST, etc.)
 * @param {object} body - Request body (will be JSON stringified)
 * @param {object} additionalHeaders - Additional headers to include
 * @returns {Promise<object>} - Decrypted response data
 */
export const fetchAuthApi = async (
  url,
  method = "GET",
  body = null,
  additionalHeaders = {}
) => {
  const token = localStorage.getItem("token");

  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...additionalHeaders,
    },
  };

  if (body && method !== "GET") {
    options.body = JSON.stringify(body);
  }

  return fetchApi(url, options);
};
